import ReactPlayer from "react-player";

import { cn } from "../../../../shared/utils/cn";

export default function VideoPostContent({ postData, className }) {
  const videoURL = (postData?.Link_URL || postData?.Link_youtube).replace(
    "shorts",
    "embed"
  );
  return (
    <div className={cn("post_content post_content_video", className)}>
      {videoURL && (
        <ReactPlayer
          width="100%"
          height="100%"
          url={videoURL}
          controls={true}
        />
      )}
    </div>
  );
}
